import React, { Component } from "react";

import "./Classes.scss";

import UiBtnBasket from "../../components/buttons/UiBtnBasket";
import UiBtnTop from "../../components/buttons/UiBtnTop";
import UiCatalogFilter from "../../components/catalog/UiCatalogFilter";
import UiCatalogCard from "../../components/cards/UiCatalogCard";
import UiHeader from "../../components/header/UiHeader";
import UiFooter from "../../components/footer/UiFooter";
import UiModalCatalog from "../../components/modals/UiModalCatalog";
import UiModalLogin from "../../components/modals/UiModalLogin";
import UiPageTitle from "../../components/header/UiPageTitle";

import { Helmet } from "react-helmet";

import { storeData, retrieveData, getBasketNum } from "../../services/Storage";

class SubscribePage extends Component {
    state = {
        showTopBtn: false,
        scrollHeader: false,
        basketNum: 0,
        modalCatalogActive: false,
        modalLoginActive: false,
        user: null,

        settings: {},
        selectedItem: {
            title: null,
            description: null,
            composition: null,
            price: null,
            modifications: null,
        },

        cart: [],
        classesList: [],
        giftsList: [],
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this._load();

        window.addEventListener("scroll", (event) => {
            let scroll = document.documentElement.scrollTop;
            this.setState({ topOffset: scroll });
            if (this.state.topOffset > 170) {
                this.setState({ scrollHeader: true });
            } else {
                this.setState({ scrollHeader: false });
            }
            if (this.state.topOffset > 500) {
                this.setState({ showTopBtn: true });
            } else {
                this.setState({ showTopBtn: false });
            }
        });
    }

    _load() {
        let _cart = retrieveData("cart");
        let _user = retrieveData("mfUser");
        if (_cart) {
            this.setState({ cart: _cart });
            this.setState({ basketNum: getBasketNum(_cart) });
        }
        if (_user) {
            this.setState({ user: _user });
        }

    }


    render() {

        return (
            <div ref={this.divPage} id="page">
                <Helmet>
                    <title>Политика обработки персональных данных MATE flowers</title>
                    <meta name="description" content="Политика в отношении обработки персональных данных" />
                    <meta name="keywords" content="цветочная подписка москва, доставка цветов москва" />
                </Helmet>
                <div id="wrapper" className="page-wrapper">
                    {/* gifts header */}
                    <section className="section classes-header">
                        <UiHeader
                            callBack={(value) => { }}
                            page="subscribe"
                            scrollHeader={this.state.scrollHeader}
                            basketNum={this.state.basketNum}
                            isLogin={this.state.user}
                            loginClick={() => this.setState({ modalLoginActive: true })}
                            profileClick={() => this.props.history.push("/profile")}
                        />
                    </section>
                    <UiCatalogFilter />
                    {/* page title */}
                    <section className="section classes-title">
                        <UiPageTitle
                            backImg={require("../../assets/images/header/bg-breacrum.jpg")}
                            pageLink="/subscribe"
                            pageName="Политика обработки персональных данных MATE flowers"
                            title=""
                        />
                    </section>
                    {/* gifts catalog */}
                    <section className="section classes-catalog">
                        <div className="wrapper">
                            <div className="classes-catalog-wrap">
                                <h2>
                                    СОГЛАСИЕ
                                    на обработку персональных данных
                                </h2>
                                <p><strong>&nbsp;</strong></p>
                                <p>Я, даю свое согласие Индивидуальному предпринимателю Гайдуковой Кристине Дмитриевне, ИНН: 371122369833, ОГРНИП: 319370200033300, (далее &mdash; Оператор) на обработку моих персональных данных: имя, номер телефона, адрес электронной почты, адрес доставки.</p>
                                <p>Моё согласие является конкретным, предметным, информированным, сознательным и однозначным.</p>
                                <p>Оператор обрабатывает персональные данные исключительно с целью исполнения обязательств (в том числе и по безвозмездным сделкам), информирования об услугах и заключения и обеспечения исполнения договора оказания услуг, предоставления доступа. Даю свое согласие на предоставление Оператором моих персональных данных третьим лицам для достижения заявленных целей обработки персональных данных.</p>
                                <p>Оператор обрабатывает персональные данные следующими способами: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, передача (доступ, предоставление), блокирование, удаление, уничтожение персональных данных</p>
                                <p>Оператор обрабатывает персональные данные как с использованием средств автоматизации, так и без использования таких средств.</p>
                                <p>Согласие действует с момента его предоставления и до момента отзыва Согласия. Я ознакомлен и понимаю, что:</p>
                                <ul>
                                    <li>имею право потребовать от Оператора прекратить обработку моих персональных данных, отправив заявление в форме электронного документа по адресу электронной почты: <a href="mailto:info@mateflowers.ru">info@mateflowers.ru;</a></li>
                                    <li>если потребую прекратить обработку персональных данных, то Оператор вправе продолжить обрабатывать данные без моего согласия (например, если у меня будет действующий договор с Оператором);</li>
                                    <li>если откажусь предоставить персональные данные, то не смогу пользоваться услугами Оператора.</li>
                                </ul>
                                <p>Оператор рассматривает заявление об отзыве согласия на обработку персональных данных в течение 30 (тридцати) календарных дней с момента его получения.</p>
                                <p>&nbsp;</p>
                                <h3>Реквизиты Оператора:</h3>
                                <p>Индивидуальный предприниматель Гайдукова Кристина Дмитриевна ИНН: 371122369833</p>
                                <p>ОГРНИП: 319370200033300</p>
                                <p>e-mail: <a href="mailto:info@mateflowers.ru">info@mateflowers.ru</a></p>

                            </div>
                        </div>
                    </section>
                    {/* gifts footer */}
                    <section className="section classes-footer">
                        <UiFooter />
                    </section>
                </div>

                <UiBtnTop showTopBtn={this.state.showTopBtn} />

                <UiBtnBasket
                    cartNum={this.state.basketNum}
                    infoActive={this.state.infoActive}
                    callBack={() => this.setState({ infoActive: false })}
                />

                <UiModalLogin
                    modalOpen={this.state.modalLoginActive}
                    modalClose={() => this.setState({ modalLoginActive: false })}
                    callBack={() => {
                        this.setState({ modalLoginActive: false });
                        this.props.history.push("/profile");
                    }}
                />

            </div>
        );
    }
}

export default SubscribePage;
